import { flow, types, getEnv } from 'mobx-state-tree'
import { CURRENCY } from 'constants/currencies'

export const Wallet = types
  .model('Wallet', {
    balance: types.number,
    currency: types.optional(
      types.enumeration([CURRENCY.USD, CURRENCY.EUR]),
      CURRENCY.USD
    ),
  })
  .actions((self) => {
    const {
      services: { paymentService },
    } = getEnv(self)

    return {
      requestBalance: flow(function* () {
        const { amount } = yield paymentService.requestBalance()
        self.balance = amount
        return amount
      }),
    }
  })
